/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Component, ViewEncapsulation, Input, ChangeDetectionStrategy} from '@angular/core';

export type MdPseudoCheckboxState = 'unchecked' | 'checked' | 'indeterminate';
/**
 * Component that shows a simplified checkbox without including any kind of "real" checkbox.
 * Meant to be used when the checkbox is purely decorative and a large number of them will be
 * included, such as for the options in a multi-select. Uses no SVGs or complex animations.
 * Note that theming is meant to be handled by the parent element, e.g.
 * `mat-primary .mat-pseudo-checkbox`.
 * 
 * Note that this component will be completely invisible to screen-reader users. This is *not*
 * interchangeable with <md-checkbox> and should *not* be used if the user would directly interact
 * with the checkbox. The pseudo-checkbox should only be used as an implementation detail of
 * more complex components that appropriately handle selected / checked state.
 * \@docs-private
 */
export class MdPseudoCheckbox {
/**
 * Display state of the checkbox.
 */
state: MdPseudoCheckboxState = 'unchecked';
/**
 * Whether the checkbox is disabled.
 */
disabled: boolean = false;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  encapsulation: ViewEncapsulation.None,
  preserveWhitespaces: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'md-pseudo-checkbox, mat-pseudo-checkbox',
  styleUrls: ['pseudo-checkbox.css'],
  template: '',
  host: {
    'class': 'mat-pseudo-checkbox',
    '[class.mat-pseudo-checkbox-indeterminate]': 'state === "indeterminate"',
    '[class.mat-pseudo-checkbox-checked]': 'state === "checked"',
    '[class.mat-pseudo-checkbox-disabled]': 'disabled',
  },
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'state': [{ type: Input },],
'disabled': [{ type: Input },],
};
}

function MdPseudoCheckbox_tsickle_Closure_declarations() {
/** @type {?} */
MdPseudoCheckbox.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdPseudoCheckbox.ctorParameters;
/** @type {?} */
MdPseudoCheckbox.propDecorators;
/**
 * Display state of the checkbox.
 * @type {?}
 */
MdPseudoCheckbox.prototype.state;
/**
 * Whether the checkbox is disabled.
 * @type {?}
 */
MdPseudoCheckbox.prototype.disabled;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
